import { api, config, formatParams } from "@/utils/axios"
import request from "@/utils/request"

// 获取部门树
export const getDepartmentTree = (params = { sectionName: "" }) => {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/sysSection/treeList?sectionName=${params.sectionName}`
    })
  )
}

// 获取部门下所有的用户
// export const getDepartmentUser = (params = { sectionId: "" }) => {
//   return api(
//     Object.assign(formatParams("GET"), {
//       url: `${config.proxy}/dynamic-form/sysSection/findUserBySid?sid=${params.sectionId}&type=1`
//     })
//   )
// }
// 人员管理 后台管理模块
export const getDepartmentUser = (data) => {
  let params = {
    ...data,
    sid: data.sectionId,
    type: 1
  }
  return request({
    // url: "/sys/person/list",
    // url: `/sysSection/findUserBySid?sid=${params.sectionId}&type=1`,
    url: `/sysSection/findUserBySid`,
    method: "get",
    params
  })
}
// 获取部门信息
export const getDepartmentInfo = (params = { sectionId: "" }) => {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/sysSection/findById?sectionId=${params.sectionId}`
    })
  )
}

// 部门批量新增人员 - 有问题
// export const addDepartmentUser = (params ) => {
//   return api(
//     Object.assign(formatParams("POST", params), {
//       url: `${config.proxy}/dynamic-form/sysSection/bindUserSection`,
//     })
//   );
// };

// 部门批量添加人员
export const addDepartmentUser = (params) => {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/sysSection/sectionAddUser`
    })
  )
}

// 部门批量删除人员
export const delDepartmentUser = (params) => {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/sysSection/sectionDelUser`
    })
  )
}

// 删除部门
export const delDepartment = (params) => {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/sysSection/delByIds`
    })
  )
}

// 修改部门
export const updateDepartment = (params) => {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/sysSection/updateById?id=${params.id}`
    })
  )
}

// 获取该用户能查询到的部门
export const getCurrentDepartmentTree = (userId) => {
  return api(
    Object.assign(formatParams("GET"), {
      url: `${config.proxy}/dynamic-form/exportRecord/sectionList/${userId}`
    })
  )
}

// 获取部门下的可以查看的部门
export const getDepartmentTreeByUserId = (userId) => {
  return api(
    Object.assign(formatParams("GET"), {
      url: `${config.proxy}/dynamic-form/section/sectionRole/${userId}`
    })
  )
}
